export const OPEN = 'MODAL/OPEN';
export const CLOSE = 'MODAL/CLOSE';

export const openModal = ({ body }) => ({ type: OPEN, body });
export const closeModal = () => ({ type: CLOSE });
